module.exports = __webpack_public_path__ + "static/media/deal-img2.d882911b.jpg";